import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import AddDriveRooms from 'src/components/driveAdmin/AddDriveRoom/AddDriveRooms';
import UpdateUserPhoneNumber from 'src/components/driveAdmin/UpdateUser/UpdateUserPhoneNumber';
import OfflineDriveCandidatesPage from 'src/pages/driveAdmin/OfflineDriveCandidatesPage';
import OfflineDriveCompaniesPage from 'src/pages/driveAdmin/OfflineDriveCompanyPage';
import Profile from 'src/pages/profile/Profile';

const DriveAdminRoutes = () => {
	return (
		<Routes>
			<Route path="/offline-drive-candidates" element={<OfflineDriveCandidatesPage />} />
			<Route path="/offline-drive-companies" element={<OfflineDriveCompaniesPage />} />
			<Route path="/update-phone-number" element={<UpdateUserPhoneNumber />} />
			<Route path="/add-drive-room" element={<AddDriveRooms />} />


			<Route path="/offline-drive-companies/:positionId" element={<OfflineDriveCandidatesPage />} />
			<Route path="/profile/:userHandler" element={<Profile />} />
			<Route path="*" element={<Navigate to="/offline-drive-candidates" />} />
		</Routes>
	);
};

export default DriveAdminRoutes;
